import { configure } from "mobx";
import CrewStore from "./stores/crewStore";
import EconomosStore from "./stores/economosStore";
import EditedEntityStore from "./stores/editedEntityStore";
import UiStore from "./stores/uiStore";
import UserStore from "./stores/userStore";

configure({
	enforceActions: "never",
});

class RootStore {
	estoEsRoot = true;

	constructor() {
		this.userStore = new UserStore(this);
		this.uiStore = new UiStore(this);
		this.crewStore = new CrewStore(this);
		this.economosStore = new EconomosStore(this);
		this.editedEntityStore = new EditedEntityStore(this);
	}
}

const rootStore = new RootStore();

export const userStore = rootStore.userStore;
export const uiStore = rootStore.uiStore;
export const crewStore = rootStore.crewStore;
export const economosStore = rootStore.economosStore;
export const editedEntityStore = rootStore.editedEntityStore;
